import g from "./globals";
import Logger from "./Logger";

const logger = new Logger(__filename);
const notImplemented = () => logger.log("Not implemented yet!");
const api = {
  zctx: null,
  eventTypes: null,
  store: null,
};
// TODO: se llama en el main tb, ver como refactorizar, ya que en el main se está asignado extensions etc y por eso lo mantengo en main
const zara = window.zara || { appConfig: null, mkt: { require: null } };
if (!zara.mkt) {
  zara.mkt = {
    require: null,
  };
}
zara.mkt.require = window._zaraRequire || window.require || null;

const init = () => {
  const zctx = window.zara && window.zara.core ? window.zara.core.context : null;
  const eventsTypes = zctx ? zctx.eventsTypes : window.Manager.Events ? window.Manager.Events : window.Manager.types;
  const store = zctx ? zctx.session.store : notImplemented;
  const apiConfig = {
    zctx,
    eventsTypes,
    store,
  };
  Object.assign(api, apiConfig);
};

const setApi = _api => Object.assign(api, _api);

const session = () => api.store;

const mktTrigger = (eventsName, args) => {
  const event = api.eventsTypes ? api.eventsTypes[eventsName] : null;
  if (!event) {
    return;
  }
  switch (true) {
    case /desktop|mobile/.test(g.channel): {
      window.Manager.trigger(event, args);
      break;
    }
    default:
      if (api.zctx) {
        api.zctx.eventsManager.publishEvent(name, ...args);
      }
  }
};

const require = (modules, fn) => {
  if (typeof zara.mkt.require !== "function") return;
  return zara.mkt.require(modules, (...args) => fn(...Array.from(args || [])));
};

const trackEvent = (action, label, type = "MKT_EVENT") => {
  let args;
  const eventNames = {
    PAGE_SHOWN: g.channel === "desktop" ? "GA_PAGE_VIEW" : "VIRTUAL_PAGE_SHOWN",
  };

  if (typeof action === "object") {
    args = action;
  } else {
    args = {
      action,
      label,
    };
  }
  mktTrigger(eventNames[type] || type, args);
};

const navigateToProduct = options => {
  if (g.channels.mobile) {
    const url = api.urlBuilder ? api.urlBuilder.productUrl(options, options.categoryId) : null;
    const list = options.catentriesList.map(value => ({
      id: value.id,
      category: options.categoryId,
    }));
    options = {
      marketing: {
        id: options.cateentryId,
        list,
        subtitle: options.title,
        url: location.href,
      },
      noLoading: true,
      url,
    };
    return zara.mkt.require(["product-utils"], ProductUtils => {
      logger.log("Abriendo ProductUtils");
      return ProductUtils.navigateToProduct(options);
    });
  }
  return notImplemented();
};

const buildUrl = (type, data, categoryId) => {
  if (api.urlBuilder) {
    switch (type) {
      case "product":
        return api.urlBuilder.productUrl(data, categoryId);
      case "category":
        return api.urlBuilder.generateCategoryUrl(data);
      default:
        return null;
    }
  }
};

const unfoldMenu = () => {
  if (g.channel === "desktop") {
    mktTrigger("DEACTIVATE_HIDDEN_MENU");
  }
};

const foldMenu = () => {
  // if (!document.querySelector("#bgMenu")) {
  //   const bgMenu = document.createElement("div");
  //   bgMenu.id = "bgMenu";
  //   const bgLogo = document.createElement("div");
  //   bgLogo.id = "bgLogo";
  //   const navigation = document.querySelector("#nav-menu-container");
  //   if (navigation) {
  //     navigation.parentNode.insertBefore(bgLogo, navigation);
  //     navigation.parentNode.insertBefore(bgMenu, navigation);
  //   }
  // }
  // if (content === false) {
  //   unfoldMenu();
  // } else {
  //   mktTrigger("ACTIVATE_HIDDEN_MENU");
  // }
};

export const firstContentReady = props => {
  if (!props) return false;
  if (
    props.carousel &&
    props.position === 0 &&
    props.carouselIndex !== null &&
    props.carouselIndex === window.selectedCarousel.activeIndex
  ) {
    if (g.channels.mobile) {
      zara.mkt.require(["plugin/performance"], Performance => {
        logger.log("Abriendo Performance");
        Performance.measure(Performance.MEASURE_MARKS.itxVisuallyReady);
      });
    } else if (g.channels.desktop) {
      zara.mkt.require(["plugins/performance"], Performance => {
        logger.log("Abriendo Performance");
        Performance.measure(Performance.MEASURE_MARKS.itxVisuallyReady);
      });
    }
  }
};

export default {
  init,
  setApi,
  mktTrigger,
  require,
  trackEvent,
  session,
  navigateToProduct,
  buildUrl,
  foldMenu,
  unfoldMenu,
  firstContentReady,
};
